import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import { Breadcrumbs, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import {
  CreateManualAttendanceForm,
  ManualRequestAttendanceCard,
} from '@/entities/manual-attendance'
import { useAttendanceCreationFlow } from '@/features/manual-attendance'
import { CustomButton } from '@/shared/ui/button'
import { PageWrapper } from '@/shared/ui/page-wrapper'

export const Route = createFileRoute(
  '/_auth/canteen/manual-attendance-and-food-receipt/item/create'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { step, autofillData, initialRecords, handleBack, handleAutofillComplete } =
    useAttendanceCreationFlow()

  return (
    <PageWrapper title={t('Создание записей учета посещения столовой и получения питания')}>
      <Box display="flex" gap={2} alignItems="center">
        <CustomButton
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={<ArrowBackIos />}
          onClick={handleBack}
        >
          {t('Назад')}
        </CustomButton>
        <Breadcrumbs separator={<ArrowForwardIos sx={{ fontSize: 16 }} />}>
          <Typography color="text.secondary" key="1">
            {t('Учёт посещения и активации ваучера')}
          </Typography>
          <Typography key="2" color="text.primary">
            {step === 'autofill'
              ? t('Автозаполнение')
              : t('Создание учёта посещения и активации ваучера')}
          </Typography>
        </Breadcrumbs>
      </Box>
      {step === 'autofill' ? (
        <ManualRequestAttendanceCard onAutofillComplete={handleAutofillComplete} />
      ) : (
        <CreateManualAttendanceForm autofillData={autofillData} initialRecords={initialRecords} />
      )}
    </PageWrapper>
  )
}
